import React, { FC } from "react";
import styles from "./FormRow.module.css";

const FormRow: FC = ({ children }) => {
  return <div className={styles.formRow}>{children}</div>;
};

export default FormRow;
